<template>
  <v-container fluid>
    <PageTitle icon="fal fa-fw fa-users">
      Email Lists
      <template v-slot:buttons>
        <v-btn :to="{name: `${$root.routePrefix}.mailcoach.list.create`}"
               color="primary"
               :disabled="busy">
          New List
        </v-btn>
      </template>
    </PageTitle>

    <template>
      <v-row>
        <v-col cols="12"
               md="3"
               xl="2">
          <v-form @submit.prevent="fetchData"
                  :disabled="busy">
            <v-card class="mb-4">
              <v-card-text class="pb-0">
                <v-text-field v-model="form.name"
                              label="Name contains"
                              outlined
                              dense
                              @change="fetchData"
                              :error-messages="formObject.errors.get('name')">
                </v-text-field>

                <v-text-field v-model.number="form.min_subscriber_count"
                              label="Minimum Contacts"
                              type="number"
                              min="0"
                              step="1"
                              outlined
                              dense
                              @change="fetchData"
                              :error-messages="formObject.errors.get('min_subscriber_count')">
                </v-text-field>

                <v-text-field v-model.number="form.max_subscriber_count"
                              label="Maximum Contacts"
                              type="number"
                              min="0"
                              step="1"
                              outlined
                              dense
                              @change="fetchData"
                              :error-messages="formObject.errors.get('max_subscriber_count')">
                </v-text-field>
              </v-card-text>
              <v-card-actions class="px-4">
                <v-btn type="submit"
                       color="primary">
                  Search
                </v-btn>
                <v-btn @click.prevent="resetForm">
                  Reset
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-col>
        <v-col cols="12"
               md="9"
               xl="10">

          <v-card class="mb-4">
            <v-card-text v-if="results.min_subscriber_count > 0"
                         class="py-1 font-weight-bold">
              <template v-if="results.max_subscriber_count > 0 && results.max_subscriber_count > results.min_subscriber_count">
                Showing {{ results.name ? `"${results.name}"` : ''}} lists with between {{ results.min_subscriber_count }} and {{ results.max_subscriber_count | pluralize('contact', true) }}.
              </template>
              <template v-else-if="results.max_subscriber_count > 0 && results.min_subscriber_count === results.max_subscriber_count">
                Showing {{ results.name ? `"${results.name}"` : ''}} lists with {{ results.max_subscriber_count | pluralize('contact', true) }}.
              </template>
              <template v-else>
                Showing {{ results.name ? `"${results.name}"` : ''}} lists with at least {{ results.min_subscriber_count | pluralize('contact', true) }}.
              </template>
            </v-card-text>
            <EmailListsTable :lists="lists"
                             :loading="busy">
            </EmailListsTable>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {isObject, omit, orderBy} from 'lodash';
import EmailListsTable from './components/EmailListsTable';
import mailcoachService from '../../services/mailcoachService';
import HelpDialog from '../../components/HelpDialog';
import PageTitle from '../../components/PageTitle.vue';
import saveState from 'vue-save-state';
import DOMPurify from 'dompurify';


const FORM_KEY = 'library_email_lists';
const FORM_VERSION = 1;

function initForm() {
  return {
    user_id: null,
    name: null,
    min_subscriber_count: 2, // MLD-7027
    max_subscriber_count: null, // MLD-7027
    version: FORM_VERSION,
  }
}

export default {
  name: 'mailcoach-email-lists',
  components: {PageTitle, HelpDialog, EmailListsTable},
  mixins: [saveState], // MLD-7027
  data() {
    return {
      busy: false,
      form: initForm(),
      results: initForm(),
      formObject: new Form(initForm),
      helpDialog: false,
      lists: [],
    }
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'isMember',
      'user',
      'team',
    ])
  },
  created() {
    this.form.user_id = this.user.id;
    this.fetchData();
  },
  methods: {
    getSaveStateConfig() { // MLD-7027
      return {
        cacheKey: FORM_KEY,
        saveProperties: [
          'form',
        ],
        onLoad: (key, value) => { // MLD-1864
          if (key === 'form' && isObject(value)) {
            if (value.version !== FORM_VERSION) {
              return initForm();
            }
          }
          return value;
        }
      }
    },
    fetchData() {
      if (this.busy) {
        return;
      }
      this.busy = true;
      const form = omit(this.form, ['version']);
      mailcoachService.getListsForUser(this.user.id, form)
        .then(data => {
          this.results.name  = this.form.name;
          this.results.min_subscriber_count  = this.form.min_subscriber_count;
          this.results.max_subscriber_count  = this.form.max_subscriber_count;
          this.lists = orderBy(data, ['updated_at', 'slug'], ['desc', 'asc']);
        })
        .catch(err => {
          if (err.response?.data?.message) {
            this.$toast.error(DOMPurify.sanitize(err.response.data.message));
          }
          this.formObject.handleErrors(err);
        })
        .finally(() => {
          this.busy = false;
        })
    },
    resetForm() {
      this.clearSavedState();
      this.form = initForm();
      this.formObject.reset();
      this.results = initForm();
      this.fetchData();
    }
  }
}
</script>
